
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.gridTemplateColumns = this.blok.columnsOverride
        ? this.getBreakpointValue(this.blok?.columnsOverride)
        : `repeat(${this.getBreakpointValue(
            this.blok?.columns
          )}, minmax(0, 1fr))`
      styles.columnGap = this.getBreakpointValue(this.blok?.columnGap)
      styles.rowGap = this.getBreakpointValue(this.blok?.rowGap)

      return styles
    },
  },
}
